import moment from 'moment'
const format = 'YYYY-MM-DD HH:mm:ss'

class ConvertToDate {
  static format (date, arg) {
    const d = moment(date)
    if (arg) {
      return d.set({
        hour: '00',
        minute: '00',
        second: '00'
      }).format(format)
    }
    return d.set({
      hour: '23',
      minute: '59',
      second: '00'
    }).format(format)
  }

  static toDay () {
    let toDay = moment()
    const dateStart = toDay.format(format)
    const dateEnd = toDay.set({
      hour: '23',
      minute: '59',
      second: '00'
    }).format(format)

    return [dateStart, dateEnd]
  }

  static morning () {
    let toDay = moment()
    toDay.add(1, 'days')

    const dateStart = toDay.set({
      hour: '00',
      minute: '00',
      second: '00'
    }).format(format)

    const dateEnd = toDay.set({
      hour: '23',
      minute: '59',
      second: '00'
    }).format(format)

    return [dateStart, dateEnd]
  }

  static thisWeek () {
    let toDay = moment()
    const day = toDay.isoWeekday()
    const dateStart = toDay.format(format)

    toDay.add((7 - day), 'days')
    const dateEnd = toDay.set({
      hour: '23',
      minute: '59',
      second: '00'
    }).format(format)

    return [dateStart, dateEnd]
  }

  static nextWeek () {
    let toDay = moment()
    const day = toDay.isoWeekday()
    toDay.add((8 - day), 'days')

    const dateStart = toDay.set({
      hour: '00',
      minute: '00',
      second: '00'
    }).format(format)
    toDay.add(7, 'days')

    const dateEnd = toDay.set({
      hour: '23',
      minute: '59',
      second: '00'
    }).format(format)

    return [dateStart, dateEnd]
  }

  static thisMonth () {
    let toDay = moment()

    const dateStart = toDay.format(format)
    toDay.add((toDay.endOf('Month').date() - toDay.date()), 'days')

    const dateEnd = toDay.set({
      hour: '23',
      minute: '59',
      second: '00'
    }).format(format)

    return [dateStart, dateEnd]
  }

  static nextMonth () {
    const toDay = moment()
    toDay.add((toDay.endOf('Month').date() - toDay.date()) + 1, 'days')

    const dateStart = toDay.set({
      hour: '00',
      minute: '00',
      second: '00'
    }).format(format)

    toDay.add((toDay.endOf('Month').date() - toDay.date()), 'days')
    const dateEnd = toDay.set({
      hour: '23',
      minute: '59',
      second: '00'
    }).format(format)

    return [dateStart, dateEnd]
  }

  static weekEnd () {
    let toDay = moment()
    let day = toDay.isoWeekday()

    if (day < 6) {
      toDay.add((6 - day - 1), 'days')
    }
    const dateStart = toDay.set({
      hour: '00',
      minute: '00',
      second: '00'
    }).format(format)

    day = toDay.isoWeekday()
    toDay.add((8 - day - 1), 'days')
    const dateEnd = toDay.set({
      hour: '23',
      minute: '59',
      second: '00'
    }).format(format)

    return [dateStart, dateEnd]
  }
}

export default ConvertToDate



// WEBPACK FOOTER //
// ./src/ConvertToDate.js